// extracted by mini-css-extract-plugin
module.exports = {"outer":"EditorWidgets_outer__qbaIg","inner":"EditorWidgets_inner__vJpIb","whiteBackground":"EditorWidgets_whiteBackground__z2P7C"};